import { giphyBlack } from '@giphy/colors'
import styled from 'styled-components'
import NumberInput from 'ui/src/components/controls/number-input'

export const TimeBar = styled.div`
    display: flex;
    padding: 10px;
`

export const Duration = styled.div`
    align-items: center;
    background: #fff;
    border-radius: 18px;
    color: ${giphyBlack};
    display: flex;
    font-weight: bold;
    height: 36px;
    justify-content: center;
    margin: 0 auto;
    width: 94px;
`

export const TimeInput = styled(NumberInput)`
    width: 110px;
`
